export default __webpack_public_path__ + "static/media/call-icon.5c4aecc0.svg";